const getDealerIdFromSlug = (slug = []) => {
    let dealerId;
    slug.forEach((segment = '') => {
        if (!isNaN(segment)) dealerId = segment;
    });
    return dealerId;
};

export default getDealerIdFromSlug;
